import { Packr, addExtension } from "msgpackr";

export type WireFormat = 'json' | 'msgpack';

export const MSGPACK_TYPE = 'application/x-msgpack';
export const JSON_TYPE = 'application/json';

addExtension( { Class: Date, write: ( date: Date ) => date.toISOString() } );

// skipValues makes msgpack drop undefined properties the way JSON.stringify
// does; msgpackr's typings do not list the option yet, hence the untyped object.
const packr_options: Record<string, unknown> = { useRecords: false, skipValues: [ undefined ] };
const packr = new Packr( packr_options );

export function encodeMsgpack( value: unknown ): Uint8Array<ArrayBuffer>
{
  return Uint8Array.from( packr.pack( value ) );
}

export function decodeMsgpack( bytes: ArrayBuffer | Uint8Array ): unknown
{
  return packr.unpack( bytes instanceof Uint8Array ? bytes : new Uint8Array( bytes ) );
}

export function encodeBody( data: unknown, format: WireFormat ): string | Uint8Array<ArrayBuffer>
{
  return format === 'msgpack' ? encodeMsgpack( data ) : JSON.stringify( data );
}

export function contentTypeFor( format: WireFormat ): string
{
  return format === 'msgpack' ? MSGPACK_TYPE : JSON_TYPE;
}

export function acceptFor( format: WireFormat ): string
{
  return format === 'msgpack' ? `${MSGPACK_TYPE}, ${JSON_TYPE};q=0.5` : JSON_TYPE;
}

export function isMsgpackContentType( type: string | null | undefined ): boolean
{
  return !!type && type.toLowerCase().startsWith( MSGPACK_TYPE );
}

export function isJsonContentType( type: string | null | undefined ): boolean
{
  return !!type && /json/i.test( type );
}

export async function decodeResponseBody( res: Response ): Promise<unknown>
{
  const type = res.headers.get( 'content-type' );
  if ( isMsgpackContentType( type ) )
    return decodeMsgpack( await res.arrayBuffer() );
  if ( isJsonContentType( type ) )
    return res.json();

  const text = await res.text();
  if ( !text ) return null;
  try { return JSON.parse( text ); }
  catch { return null; }
}
